import { Subject } from "rxjs";
import { Injectable } from "@angular/core";
import { WorkspaceServiceService } from "./workspace-service.service";

@Injectable({
    providedIn: "root"
})
export class WakeUpService {
    public wakeUpSubscriber: Subject<void> = new Subject<void>();

    private _lastTime: number = 0;
    public get lastTime(): number {
        return this._lastTime;
    }

    private TIMEOUT: number = 5000; //

    IsLoged(): boolean {
        var userName = sessionStorage.getItem("userName");
        return userName != undefined && userName != "";
    }

    constructor() {
        this._lastTime = new Date().getTime();
        setInterval(() => {
            let currentTime = new Date().getTime();

            let d = Math.abs(currentTime - this._lastTime);
            if (d > 1000 * 60) {
                if (this.IsLoged()) {
                    this.wakeUpSubscriber.next();
                }
            }
            this._lastTime = currentTime;
        }, this.TIMEOUT);
    }
}
